// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/css-loader/index.js??ref--11-2!../../../node_modules/sass-loader/dist/cjs.js??ref--11-3!./question-review.scss");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../node_modules/vue-style-loader/lib/addStylesClient.js")("82785c9c", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/views/question-review/question-review.scss
// module id = 1569
// module chunks = 5 34 108 122